module.exports = __webpack_public_path__ + "img/bgimg.8342e69c.png";